import { AdminSettingsPage } from 'src/views/abi/AdminSettingsPage'
import pathMap from 'src/paths/pathMap'

class AbiAdminSettingsRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_ADMIN_SETTINGS_PATH,
        component: AdminSettingsPage
      }
    ]
  }
}

export default AbiAdminSettingsRoute
